/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MeResponseAllOf,
    MeResponseAllOfFromJSON,
    MeResponseAllOfFromJSONTyped,
    MeResponseAllOfToJSON,
} from './MeResponseAllOf';
import {
    MeResponseAllOfData,
    MeResponseAllOfDataFromJSON,
    MeResponseAllOfDataFromJSONTyped,
    MeResponseAllOfDataToJSON,
} from './MeResponseAllOfData';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';

/**
 * ログインしているユーザー情報を取得したときのレスポンス
 * @export
 * @interface MeResponse
 */
export interface MeResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof MeResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof MeResponse
     */
    message: string;
    /**
     * 
     * @type {MeResponseAllOfData}
     * @memberof MeResponse
     */
    data: MeResponseAllOfData;
}

export function MeResponseFromJSON(json: any): MeResponse {
    return MeResponseFromJSONTyped(json, false);
}

export function MeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': MeResponseAllOfDataFromJSON(json['data']),
    };
}

export function MeResponseToJSON(value?: MeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': MeResponseAllOfDataToJSON(value.data),
    };
}

